export default "__VITE_ASSET__DHHBu9Ul__"